import React from 'react';
import { Link } from 'react-router-dom';
import './Books.css';

const Books = ({ books }) => {
  return (
    <div className="books-container">
      <h1 className="books-title">KÖNYVEIM</h1>
      <div className="book-gallery">
        {books.map(book => (
          <Link to={`/konyv/${book.id}`} key={book.id} className="book-gallery-card">
            <img src={book.coverImage} alt={`${book.title} borító`} className="gallery-cover" />
            <div className="gallery-card-overlay">
              <h3 className="gallery-card-title">{book.title}</h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Books;